import { Type } from "@angular/core";
import { ApplicationRef, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import _get from "lodash/get";
import _flatten from "lodash/flatten";
import { VenuesSearchComponent } from "apps-module/app/entry-modules/venues-search/venues-search.component";
import { VenuesSearchModule } from "apps-module/app/entry-modules/venues-search/venues-search.module";
import { VacanciesSearchComponent } from "apps-module/app/entry-modules/vacancies-search/vacancies-search.component";
import { VacanciesSearchModule } from "apps-module/app/entry-modules/vacancies-search/vacancies-search.module";
import { ContentSearchModule } from "apps-module/app/entry-modules/content-search/content-search.module";
import { ContentSearchComponent } from "apps-module/app/entry-modules/content-search/content-search.component";
import { AssistantsProfileSearchComponent } from "apps-module/app/entry-modules/assistants-profile-search/assistants-profile-search.component";
import { AssistantsProfileSearchModule } from "apps-module/app/entry-modules/assistants-profile-search/assistants-profile-search.module";
import { EventSearchComponent } from "apps-module/app/entry-modules/event-search/event-search.component";
import { EventSearchModule } from "apps-module/app/entry-modules/event-search/event-search.module";
import { NewsSearchModule } from "apps-module/app/entry-modules/news-search/news-search.module";
import { NewsSearchComponent } from "apps-module/app/entry-modules/news-search/news-search.component";
import {CharitySearchModule} from "./entry-modules/charity-search/charity-search.module";
import {CharitySearchComponent} from "./entry-modules/charity-search/charity-search.component";

const entryComponents: Array<Type<any>> = [
    VenuesSearchComponent,
    VacanciesSearchComponent,
    ContentSearchComponent,
    EventSearchComponent,
    AssistantsProfileSearchComponent,
    NewsSearchComponent,
    CharitySearchComponent
];

@NgModule({
    imports: [
        BrowserModule,
        VenuesSearchModule,
        VacanciesSearchModule,
        ContentSearchModule,
        EventSearchModule,
        AssistantsProfileSearchModule,
        NewsSearchModule,
        CharitySearchModule
    ],
    entryComponents: entryComponents
})
export class AppModule {
    public ngDoBootstrap(applicationRef: ApplicationRef): void {
        entryComponents
            .map(component => ({
                component: component,
                nodes: [...document.querySelectorAll( _get(component, "SELECTOR"))] as Array<Node>
            }))
            .forEach(relation => {
                relation.nodes.forEach(node => {
                    applicationRef.bootstrap(relation.component, node);
                });
            });
    }
}
